import CreateCustomer from './components/CreateCustomer.vue';
import CustomersOverview from './components/CustomersOverview.vue';
import customerMixin from './mixins/customer.js';
import CustomersApi from './services/api/customer.js';

export { CreateCustomer, CustomersOverview, customerMixin, CustomersApi };
